// src/mocks/handlers/account/index.ts

import { businessDetailsHandler } from './businessDetailsHandler';
import { businessDetailsUpdateHandler } from './businessDetailsUpdateHandler';
import { collectionAccountsHandler } from './collectionAccountsHandler';
import { kycConnectedAccountHandler } from './kycConnectedAccountHandler';
import { kycProcessHandler } from './kycProcessHandler';
import { kycStatusHandler } from './kycStatusHandler';
import { payoutAccountsHandler } from './payoutAccountsHandler';
import { payoutAccountCreateHandler } from './payoutAccountCreateHandler';
import {
  financialReportsCreateHandler,
  financialReportsDownloadHandler,
  financialReportsHandler,
} from './financialReportsHandler';

export const accountHandlers = [
  businessDetailsHandler,
  businessDetailsUpdateHandler,
  collectionAccountsHandler,
  payoutAccountsHandler,
  payoutAccountCreateHandler,
  kycStatusHandler,
  kycConnectedAccountHandler,
  kycProcessHandler,
  financialReportsHandler,
  financialReportsCreateHandler,
  financialReportsDownloadHandler,
];
